import { ArrowLeft } from "lucide-react"
import { Button } from "@/components/ui/button"
import { useNavigate } from "react-router-dom"

type DeviceDetailHeaderProps = {
  councilId: string
  deviceId: string
}

export default function DeviceDetailHeader({
  councilId: _councilId,
  deviceId: _deviceId,
}: DeviceDetailHeaderProps) {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col gap-4 mb-6 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-4">
        <Button
          variant="outline"
          size="sm"
          onClick={() => navigate(-1)}
          className="flex items-center gap-2"
        >
          <ArrowLeft className="size-4" />
          Back
        </Button>
        <div>
          <h1 className="text-3xl font-bold">Device Dashboard</h1>
          <p className="text-muted-foreground">
            Monitor device information and real-time water consumption
          </p>
        </div>
      </div>
    </div>
  )
}
